module.exports = __webpack_public_path__ + "img/02.b896bd3c.jpg";